// extracted by mini-css-extract-plugin
export default {"qrCodeModal":"OwnerQrscan_qrCodeModal__B2ZLy","qrVideo":"OwnerQrscan_qrVideo__jGI8U","qrResult":"OwnerQrscan_qrResult__mBuu3"};